import { Roles } from '#shared/types/enums'

export default defineNuxtRouteMiddleware(async () => {
  const { dbUser, waitForDbUser } = useUser()

  await waitForDbUser()

  if (dbUser.value.role_id < Roles.ADMIN) {
    return abortNavigation()
  }
})
